
export interface StaffPermissions {
	isSoftwareDev: boolean,
	canManageVolunteerStaff: boolean,
	canRecruitVolunteers: boolean,
	canCoordinateVolunteers: boolean,
	canDirectlyAssignSpecialist: boolean,
	canEnrollEntrepreneurs: boolean,
	canManageAdmissionsStaff: boolean,
	canFacilitateCohorts: boolean,
	canCloseAdmissions: boolean,
	canEditAccSchedules: boolean,
	canDownloadProgramData: boolean,
	canDownloadProgramDataWithPersonalInfo: boolean,
}


export const NO_PERMISSIONS: StaffPermissions = {
	isSoftwareDev: false,
	canManageVolunteerStaff: false,
	canRecruitVolunteers: false,
	canCoordinateVolunteers: false,
	canDirectlyAssignSpecialist: false,
	canEnrollEntrepreneurs: false,
	canManageAdmissionsStaff: false,
	canFacilitateCohorts: false,
	canCloseAdmissions: false,
	canEditAccSchedules: false,
	canDownloadProgramData: false,
	canDownloadProgramDataWithPersonalInfo: false,
}
